"use client";

import Text from "@/lib/components/Text";
import { OverlayViewF, OVERLAY_MOUSE_TARGET } from "@react-google-maps/api";
import { RoomProps } from "../Room";
import { LanguageParams } from "@/lib/types/PageProps";

type Props = {
    listing: RoomProps;
    onOpen: () => void;
    isSelected: boolean;
} & LanguageParams;

const Marker = ({ listing, onOpen, lang, isSelected }: Props) => {
    const getPrice = (price: number) => {

        return Math.round(price / 100).toLocaleString("de-DE");
    };

    const selectedStyles = isSelected ? "bg-cyan-500 text-white z-10" : "bg-white text-black z-0";
    const borderStyles = isSelected ? "border-t-cyan-500 z-10" : "border-t-white z-0";

    return (
        <OverlayViewF
            position={{ lat: listing.location.lat, lng: listing.location.lng }}
            mapPaneName={OVERLAY_MOUSE_TARGET}
            getPixelPositionOffset={(offsetWidth, offsetHeigt) => ({ x: -(offsetWidth / 2), y: -offsetHeigt })}
        >
            <div
                className={`relative ${selectedStyles} -mt-px rounded-lg shadow-md flex items-baseline p-2`}
                onClick={onOpen}
            >
                <Text className="font-sans font-bold text-base">
                    {lang === "en"
                        ? `€ ${getPrice( listing.pricePerMonth)}`
                        : `${getPrice( listing.pricePerMonth)} €`}
                </Text>
            </div>
            <div className="flex justify-center">
                <div className={`h-0 w-0 border-x-[10px] border-x-transparent border-t-[8px] ${borderStyles}`}></div>
            </div>
        </OverlayViewF>
    );
};

export default Marker;
